// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import { DotsLoader } from 'app/common/components/Loader';
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';
import { useCurrencySign } from 'app/common/components-next/currency';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';
import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon';

import styles from './OrderFormHeader.module.scss';;


type Props = {
  className?: string,
  children?: Node,
  balance: number | null,
  balanceAvailable: number | null,
  onCrossClick?: (e: SyntheticEvent<HTMLElement>) => void,
}

const OrderFormHeader = ({
  className,
  children,
  balance,
  balanceAvailable,
  onCrossClick,
}: Props) => {
  const currency = useCurrencySign();

  return (
    <div className={cn(styles.root, className)}>
      {onCrossClick
        && <PlainButtonAsLink onClick={onCrossClick}>
          <PlainIcon type={iconTypes.CROSS_BOLD} />
        </PlainButtonAsLink>}

      {children}

      <div className={styles.space} />
      <div className={styles.balance}>
        <div>
          {'Баланс: '}
          {typeof balance !== 'number'
            ? <DotsLoader className={styles.dots} />
            : toFixedValueCurrency(balance, false, currency)}
        </div>
        <div>
          {'Доступно: '}
          {typeof balanceAvailable !== 'number'
            ? <DotsLoader className={styles.dots} />
            : toFixedValueCurrency(balanceAvailable, false, currency)}
        </div>
      </div>
    </div>
  );
};

export default OrderFormHeader;
